import { render, staticRenderFns } from "./threeD.vue?vue&type=template&id=dbd97ebe&scoped=true"
import script from "./threeD.vue?vue&type=script&lang=js"
export * from "./threeD.vue?vue&type=script&lang=js"
import style0 from "./threeD.vue?vue&type=style&index=0&id=dbd97ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd97ebe",
  null
  
)

export default component.exports